import React, { useState } from "react";
import { Slider } from "@/components/ui/slider";
import { UploadZone, DownloadButton, ResetButton, loadImage } from "./_shared";

function makeAdjustTool({ prop, min, max, step, defaultVal, filterFn, downloadPrefix }) {
  return function Tool() {
    const [file, setFile] = useState(null);
    const [val, setVal] = useState(defaultVal);
    const [src, setSrc] = useState(null);
    const [outUrl, setOutUrl] = useState(null);

    const process = async (f, v) => {
      const { img } = await loadImage(f);
      const canvas = document.createElement("canvas");
      canvas.width = img.naturalWidth; canvas.height = img.naturalHeight;
      const ctx = canvas.getContext("2d");
      ctx.filter = filterFn(v);
      ctx.drawImage(img, 0, 0);
      canvas.toBlob((blob) => {
        if (outUrl) URL.revokeObjectURL(outUrl);
        setOutUrl(URL.createObjectURL(blob));
      }, "image/png", 0.95);
    };

    const handleFile = async (f) => { setFile(f); setSrc(URL.createObjectURL(f)); await process(f, val); };
    const reset = () => { setFile(null); setSrc(null); setOutUrl(null); setVal(defaultVal); };

    if (!file) return <UploadZone onFile={handleFile} />;
    return (
      <div className="space-y-6">
        <div className="rounded-2xl border border-slate-200 dark:border-white/10 overflow-hidden bg-slate-50 dark:bg-[#0b0c0e] p-4">
          {outUrl && <img src={outUrl} alt="preview" className="w-full max-h-96 object-contain" />}
        </div>
        <div className="rounded-2xl border border-slate-200 dark:border-white/10 p-6 bg-white dark:bg-[#121316]">
          <div className="flex items-center justify-between mb-3">
            <label className="text-sm font-medium text-slate-700 dark:text-slate-200 capitalize">{prop}</label>
            <span className="text-sm text-slate-500 dark:text-slate-400">{val}{prop === "blur" ? "px" : "%"}</span>
          </div>
          <Slider value={[val]} min={min} max={max} step={step} onValueChange={(v) => setVal(v[0])} onValueCommit={() => process(file, val)} data-testid={`${prop}-slider`} />
        </div>
        <div className="flex items-center gap-3">
          <DownloadButton href={outUrl} filename={`${downloadPrefix}-${file.name}`}>Download</DownloadButton>
          <ResetButton onClick={reset} />
        </div>
      </div>
    );
  };
}

export const BrightnessTool = makeAdjustTool({ prop: "brightness", min: 0, max: 200, step: 5, defaultVal: 120, filterFn: (v) => `brightness(${v}%)`, downloadPrefix: "bright" });
export const ContrastTool = makeAdjustTool({ prop: "contrast", min: 0, max: 200, step: 5, defaultVal: 130, filterFn: (v) => `contrast(${v}%)`, downloadPrefix: "contrast" });
export const BlurTool = makeAdjustTool({ prop: "blur", min: 0, max: 30, step: 1, defaultVal: 5, filterFn: (v) => `blur(${v}px)`, downloadPrefix: "blur" });
export const GrayscaleTool = makeAdjustTool({ prop: "grayscale", min: 0, max: 100, step: 5, defaultVal: 100, filterFn: (v) => `grayscale(${v}%)`, downloadPrefix: "grayscale" });
